import { isEmpty, omitBy } from 'lodash'

/**
 * Compose query string from form values object.
 * @param {Object<string, any>} formValues
 * @return {string} Params encoded as query string.
 */
export const composeFormValueQueryString = (formValues) => {
  const params = omitBy(formValues, isEmpty)
  const urlParams = new URLSearchParams(params)
  return urlParams.toString()
}
